import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';
import { Radio as Radio$1 } from 'react-aria-components';

const radioStyles = css`
  ${Typography.Body1}

  display: flex;
  align-items: center;
  gap: var(--zds-space-6, 5px);
  color: var(--zds-text-default, ${Colors.GrayWarm10});
  forced-color-adjust: none;
  position: relative;
  padding-left: var(--zds-space-2);

  // border
  &:before {
    content: '';
    display: block;
    /* min-width ensures that the radio doesn't become an oval when content gets long */
    min-width: var(--zds-size-20, 20px);
    height: var(--zds-size-20, 20px);
    box-sizing: border-box;
    border: var(--zds-size-2, 2.288px) solid
      var(--zds-stroke-default, ${Colors.GrayWarm6});
    border-radius: var(--zds-radius-pill, 20px);
  }

  // dot
  &:after {
    position: absolute;
    left: var(--zds-space-8, 6.416px);
    border-radius: var(--zds-radius-pill, 20.576px);
    content: '';
    width: var(--zds-size-8, 7.5px);
    height: var(--zds-size-8, 7.5px);

    opacity: 0;
  }

  &[data-pressed]:before {
    border-color: var(--zds-ui-primary-stronger, ${Colors.BrandNight});
  }

  &[data-selected] {
    ${Typography.Body3}

    &:before {
      border-color: var(
        --zds-ui-primary-stronger,
        ${Colors.UiPrimaryStrongest}
      );
    }

    &:after {
      background-color: var(
        --zds-ui-primary-stronger,
        ${Colors.UiPrimaryStrongest}
      );
      opacity: 1;
    }

    &[data-pressed]:before {
      border-color: var(--zds-ui-primary-stronger, ${Colors.BrandNight});
    }
  }

  &[data-focus-visible] {
    outline: var(--zds-border-focus, 2px solid ${Colors.UiPrimaryStrongest});
    outline-offset: var(--zds-space-2px, 3px);
  }

  &[data-disabled]:before,
  &[data-disabled]:after {
    border-color: var(--zds-stroke-default, ${Colors.GrayWarm5});
  }

  &[data-invalid] {
    color: var(--zds-status-error-stronger, ${Colors.StatusErrorStrongest});
  }

  &[data-invalid]:before {
    border-color: var(
      --zds-status-error-stronger,
      ${Colors.StatusErrorStrongest}
    );
  }

  &[data-invalid]:after {
    background-color: var(
      --zds-status-error-stronger,
      ${Colors.StatusErrorStrongest}
    );
  }

  /* This selector intentionally comes after the data-invalid selectors so that data-disabled styles don't get overwritten by data-invalid styles */
  &[data-disabled] {
    cursor: not-allowed;
    background-color: var(--zds-background-stronger);
    color: var(--zds-text-weakest, ${Colors.GrayWarm5});

    &[data-selected]:after {
      background-color: var(--zds-text-weakest, ${Colors.GrayWarm5});
      opacity: 1;
    }
  }
`;
const Radio = (_a) => {
  var { children } = _a, props = __rest(_a, ["children"]);
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    jsx(Radio$1, Object.assign({ css: radioStyles, "data-zds": true }, props), children)
  );
};

export { Radio };
//# sourceMappingURL=Radio.es.js.map
